import { smoothScrollToElement } from './scroll';

export const onClickAccHandler = (opened, id, hash) => {
    if (hash != id && !(sectionIsOpen(opened, id))) {
        return [opened, true, true];
    } else if (hash == id && !(sectionIsOpen(opened, id))) {
        opened = toggleSection(opened, id);
        return [opened, false, true];
    } else if (hash == id) {
        opened = toggleSection(opened, id);
        return [opened, false, false];
    }

    return [opened, true, false];
};

export const toggleSection = (opened, next) => {
    if (sectionIsOpen(opened, next)) {
        return opened.filter(item => item !== next);
    }

    opened.push(next);
    return opened;
};

export function sectionIsOpen(opened, next) {
    return opened.includes(next);
}

export const accScroll = (chapter, ms) => {
    const selector = chapter == 'main' ? 'main' : `#${chapter}`;

    checkElement(selector).then((element) => {
        setTimeout(() => {
            smoothScrollToElement(element);
        }, ms);
    });
};

const rafAsync = () => {
    return new Promise((resolve) => {
        requestAnimationFrame(resolve);
    });
};

const checkElement = async (selector) => {
    const element = document.querySelector(selector);

    while (element === null) {
        await rafAsync();
    }

    return element;
};
